import type { HighlightsSetup, HighlightsState, MutationClass } from '../../../models'
import type { StorageService } from '../../../services'

import { CONTAINER } from '../../../config'

import { TYPES } from '../../../config/inversify.types'

import { HIGHLIGHTS_CONSTS } from '../highlights.consts'

export class SetSetupMutation implements MutationClass {
  static execute(this: void, state: HighlightsState, setup: Record<string, HighlightsSetup>): void {
    const storageService: StorageService = CONTAINER.get<StorageService>(TYPES.StorageService)
    try {
      const stringified = JSON.stringify(setup)
      storageService.setItem(HIGHLIGHTS_CONSTS.storage.setup, stringified)
    } catch (error) {
      console.error(error)
    }
    state.setup = setup
  }
}
